<!-- 项目文件 -->
<template>
    <div>
        <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p">
            <div class="w1200 mauto mt50 mb50 bgfff overflow">
                <div class="bgf6 w65p disinblock floatl pl30 pr30 baee">
                    <div class="pt20 pb20 textc  border2 mauto">
                        <p class="fs20 c333 disinblock w80p"> {{newsBanner.Title}} </p>
                        <p class="fs14 c666 pt10 pb10">
                            <span class="fs14 c666 mr10"> 发布时间 :  {{newsBanner.Time | formatDate}} </span>
                            <span class="fs14 c666 ml10"> 作者 : {{newsBanner.Author || '暂无' }} </span>
                        </p>
                    </div>
                    <div class="pt15 pb15" v-html="newsBanner.Detail">
                    </div>
                </div>
                <Registration :Area_id="Area_idX"></Registration>
            </div>
        </div>
        <Footer></Footer>  
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import Registration from '@/components/Registration'
    import $axios from "axios";
    import $ from "jquery";
    export default {
        data() {
            return {
                color: 1,
                link: 2,
                titleList: 4,
                logo: 'home',
                cityName: '',
                newsBanner: {
                    Detail: '',
                    Title: '',
                    Author: '',
                    Time: '',
                },
                Area_idX: ''
            };
        },
        components: {
            Header,
            Footer,
            Registration
        },
        filters: {
            formatDate(value) {
                var d = new Date(parseInt(value) * 1000);
                return (d.getFullYear()) + '-' + (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' +
                    (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
            }
        },
        methods: {
            getBanert() {
                let that = this;
                that.Area_idX = that.$route.query.cityid;
                let bannerid = that.$route.query.BanerId;
                $axios.post('/find/getBannerList.do').then(function(res) {
                    that.newsBanner = res.data.obj[bannerid];
                    that.newsBanner.Detail = that.newsBanner.content;
                    that.newsBanner.Title = that.newsBanner.title;
                    that.newsBanner.Author = that.newsBanner.author;
                    that.newsBanner.Time = that.newsBanner.create_time;

                }).catch(function(error) {
                    console.log(error);
                });
            },
        },
        created() {
            this.getBanert();
            this.cityName = this.$store.state.cityName;
        },

        computed: {

        },
    }
</script>
<style scoped>

</style>